import React, { useState } from 'react';
import Dialog from 'screens/shared/dialog';
import { DialogContentText, Button } from '@mui/material';
import TextField from 'screens/shared/form/input-field';

export default ({
  show = false,
  title = 'Attention',
  message = 'Are you sure? This operation can not be undone.',
  onClose = null,
  yesButtonText = 'Yes, I\'m sure',
  noButtonText = 'Cancel',
  typeText = 'DELETE',
  isPassword = false,
}) => {
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');

  const yesButtonHandler = () => {
    if (!isPassword) return onClose(true);
    if (pass.toLowerCase() === typeText.toLowerCase()) {
      setError('');
      setPass('');
      return onClose(true);
    }
    return setError(`Please enter "${typeText}" to confirm!`);
  };

  const cancelButtonHandler = () => {
    setError('');
    setPass('');
    onClose(false);
  };

  const actions = (
    <>
      <Button
        onClick={cancelButtonHandler}
        variant="contained"
        size="small"
      >
        {noButtonText}
      </Button>
      <Button
        onClick={yesButtonHandler}
        autoFocus
        variant="contained"
        size="small"
        // color="primary"
        style={{ background: 'var(--color-danger)', color: 'white' }}
      >
        {yesButtonText}
      </Button>
    </>
  );

  const content = (
    <div>
      <DialogContentText>
        {message}
      </DialogContentText>
      {isPassword && (
        <TextField
          value={pass}
          error={error}
          onChange={(e) => setPass(e)}
          label={`Type in ${typeText} to confirm`}
          className="w-100p color-danger"
        />
      )}
    </div>
  );

  return (
    <Dialog
      show={show}
      actions={actions}
      content={content}
      title={<span style={{ color: 'var(--color-danger)' }}>{title}</span>}
      titleClassName="p-b-10"
      onClose={() => onClose(false)}
    />
  );
};
